<template>
  <div>
    <div :class="this.$route.name !== 'AIFlashPaint' ? 'footer' : 'AiFlashDrawingFooter'">
      <p class="text-center property link">Beijing Yixin Technology Co. Ltd., No. 11-11, 38 Haidian Street, Haidian District, BEIJING, CN &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;</p>
      <p class="text-center property link">Service Channel: Support@yeeheart.com
      <a style="cursor: pointer;" @click="toAgreement">&emsp;{{this.$al.login.agreement}}</a>&ensp;/&ensp;
       <a @click="toPrivacy" style="cursor: pointer;">{{this.$al.login.policy}}</a>&ensp;/&ensp;
       <a  style="cursor: pointer;" @click="toRefundPolicy">{{this.$al.login.Refund}}</a></p>
       <p class="text-center property" style="padding:20px 0 70px 0;">
         Copyright © 2022 Photosir. All rights reserved . The order process, tax issue and invoicing to end user is conducted by YeeHeart .
       </p>
    </div>
    <!--隐私政策-->
    <el-dialog
      title=""
      custom-class="privacy"
      append-to-body
      :visible.sync="privacySee"
      top="10vh"
      :center="true"
      :show-close="false"
    >
      <iframe
        style="width: 100%; height: 500px; border: none"
        :src="websiteBaseUrl + this.$al.login.privacyPolicyUrl"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="privacySee = false">
          {{this.$al.login.close}}
        </el-button>
      </span>
    </el-dialog>
     <!--用户协议-->
    <el-dialog
      title=""
      custom-class="privacy"
      append-to-body
      :visible.sync="agreementSee"
      top="10vh"
      :center="true"
      :show-close="false"
    >
      <!--<privacy></privacy>-->
      <iframe
        style="width: 100%; height: 500px; border: none"
        :src="websiteBaseUrl + this.$al.login.userAgreementUrl"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="agreementSee = false">{{
          this.$al.login.close
        }}</el-button>
      </span>
    </el-dialog>

      <!--退款协议-->
    <el-dialog
      title=""
      custom-class="privacy"
      append-to-body
      :visible.sync="refundSee"
      top="10vh"
      :center="true"
      :show-close="false"
    >
      <iframe
        style="width: 100%; height: 500px; border: none"
        :src="websiteBaseUrl + this.$al.login.RefundPolicyUrl"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="refundSee = false">
          {{this.$al.login.close}}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      agreementSee:false,
      privacySee: false,
      refundSee:false,
      websiteBaseUrl: window.SITE_CONFIG.websiteBaseUrl
    }
  },
  methods: {
    //隐私政策
    toPrivacy(){
      this.privacySee = true
    },  //隐私政策
    toRefundPolicy(){
      this.refundSee = true
    },
     //用户协议
      toAgreement() {
        this.agreementSee = true;
      },
  }
}
</script>

<style scoped>
  .AiFlashDrawingFooter{
    background: linear-gradient( 128deg, #3467FF 0%, #FF00E6 100%);
  }
  .footer{
    background: #181A1E;
    width: 100%;
    
  }
  .link{
    font-weight: 400;
    line-height: 33px;
    padding-top: 25px;
    font-size: 17px;
  }
  .link a{
    color: #3564FF;
  }
  .property{
    font-size: 17px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 33px;
    margin-bottom: 0;
  }

  .custom-el-dialog-iframe{
    width: 100%;
    min-height: 500px;
    border: none;
  }
  @media (max-width: 1200px){

    .link{
      font-size: 18px;
    }
    .property{
      font-size: 18px;
    }
    .custom-el-dialog-iframe{
      min-height: 450px;
    }
  }

  @media (max-width: 1100px){

    .link{
      font-size: 17px;
    }

    .property{
      font-size: 17px;
    }
    .custom-el-dialog-iframe{
      min-height: 400px;
    }
  }
  @media (max-width: 992px){

    .link{
      font-size: 16px;
    }
    .property{
      font-size: 16px;
    }
    .custom-el-dialog-iframe{
      min-height: 350px;
    }
  }
  @media (max-width: 768px){

    .link{
      font-size: 14px;
    }
    .property{
      font-size: 14px;
    }
    .custom-el-dialog-iframe{
      min-height: 300px;
    }
  }
  @media (max-width: 540px){

    .link{
      font-size: 13px;
      padding-top: 37px;
      line-height: 24px;
      margin-bottom: 0px;
    }
    .property{
      font-size: 13px;
      padding-bottom: 35px;
    }
    .custom-el-dialog-iframe{
      min-height: 250px;
    }
  }
  @media (max-width: 414px){

    .link{
      font-size: 12px;
      padding-top: 27px;
      line-height: 24px;
      margin-bottom: 0px;
    }
    .property{
      font-size: 12px;
      padding-bottom: 30px;
    }
    .custom-el-dialog-iframe{
      min-height: 200px;
    }
  }
  @media (max-width: 375px){

    .link{
      font-size: 12px;
      padding-top: 27px;
      line-height: 24px;
      margin-bottom: 0px;
    }
    .property{
      font-size: 12px;
      padding-bottom: 30px;
    }
    .custom-el-dialog-iframe{
      min-height: 150px;
    }
  }
</style>
<style>
  .privacy{
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/Footer.vue